import { render, staticRenderFns } from "./AdminControls.vue?vue&type=template&id=794c8c1a&scoped=true&"
import script from "./AdminControls.vue?vue&type=script&lang=js&"
export * from "./AdminControls.vue?vue&type=script&lang=js&"
import style0 from "./AdminControls.vue?vue&type=style&index=0&id=794c8c1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794c8c1a",
  null
  
)

export default component.exports